import { useResultPromiseInitializer, useResultPromiseRef, useResultPromiseResolvers } from 'forms-ai-lib/internal/providers/ResultPromiseContext';
import { useDispatch, useSelector } from 'forms-ai-lib/internal/hooks/redux';
import { openCreateCustomerAgentActionWizardAction, closeCreateCustomerAgentActionWizardAction } from 'forms-ai-lib/internal/actions/customerAgent';
import { selectIsCreateCustomerAgentOpen } from 'forms-ai-lib/internal/selectors/config';
import { useStableFunction } from 'forms-ai-lib/internal/hooks/useStableFunction';
export const useCreateCustomAgentActionWizard = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsCreateCustomerAgentOpen);
  const resultPromiseRef = useResultPromiseRef();
  const initializeResultPromise = useResultPromiseInitializer();
  const {
    queueResolve
  } = useResultPromiseResolvers();
  const openCreateCustomerAgentActionWizard = useStableFunction(({
    formId
  }) => {
    const promise = initializeResultPromise();
    dispatch(openCreateCustomerAgentActionWizardAction(formId));
    return promise;
  });
  const closeCreateCustomerAgentActionWizard = useStableFunction(() => {
    if (isOpen) {
      dispatch(closeCreateCustomerAgentActionWizardAction());
    }
  });
  const forceCloseCreateCustomerAgentActionWizard = useStableFunction(() => {
    if (!isOpen || resultPromiseRef.current === null) {
      return Promise.resolve({
        cancelled: true
      });
    }
    queueResolve({
      cancelled: true
    });
    dispatch(closeCreateCustomerAgentActionWizardAction());
    return resultPromiseRef.current.promise;
  });
  return {
    isOpen,
    closeCreateCustomerAgentActionWizard,
    openCreateCustomerAgentActionWizard,
    forceCloseCreateCustomerAgentActionWizard
  };
};